import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from "../../api/api";

// Async thunk to add a comment
export const addComment = createAsyncThunk(
    'comments/addComment',
    async (commentData, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/comments/add', commentData, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Async thunk to fetch comments
export const fetchComments = createAsyncThunk(
    'comments/fetchComments',
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/comments', info, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Async thunk to update a comment
export const updateComment = createAsyncThunk(
    'comments/updateComment',
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(`/comments/update`, info, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Async thunk to delete a comment
export const deleteComment = createAsyncThunk(
    'comments/deleteComment',
    async (id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.delete(`/comments/delete/${id}`, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

const commentsSlice = createSlice({
    name: 'comments',
    initialState: {
        comments: [],
        successMessage: '',
        errorMessage: '',
        loader: false,
        totalComments: 0
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = "";
            state.successMessage = "";
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addComment.pending, (state) => {
                state.loader = true;
            })
            .addCase(addComment.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload.error;
            })
            .addCase(addComment.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.successMessage = payload.message;
                state.comments.push(payload.comment);
            })
            .addCase(fetchComments.pending, (state) => {
                state.loader = true;
            })
            .addCase(fetchComments.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload.error;
            })
            .addCase(fetchComments.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.comments = payload.comments;
                state.totalComments = payload.totalComments;
            })
            .addCase(updateComment.pending, (state) => {
                state.loader = true;
            })
            .addCase(updateComment.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload.error;
            })
            .addCase(updateComment.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.successMessage = payload.message;
                const index = state.comments.findIndex(comment => comment._id === payload.comment._id);
                if (index !== -1) {
                    state.comments[index] = payload.comment;
                }
            })
            .addCase(deleteComment.pending, (state) => {
                state.loader = true;
            })
            .addCase(deleteComment.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload.error;
            })
            .addCase(deleteComment.fulfilled, (state, action) => {
                state.loader = false;
                state.comments = state.comments.filter(comment => comment._id !== action.meta.arg);
                state.successMessage = action.payload.message;
            });
    }
});

export default commentsSlice.reducer;
export const { messageClear } = commentsSlice.actions;